import { apiRoutesV2 } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  show(slug) {
    const url = apiRoutesV2.morphedPacks(slug);
    return FetchHelpers.get(url);
  },
  status(slug) {
    const url = `${apiRoutesV2.morphedPacks(slug)}/status`;
    return FetchHelpers.get(url);
  },
  standardPhotos(slug) {
    const url = `${apiRoutesV2.morphedPacks(slug)}/morphed_photos`;
    return FetchHelpers.post(url);
  },
};
